import axios from 'axios';
import { API_ROOT } from '../service/Services';

export const GetLoginUserDetails = async () => {
    try{
        const response = await axios.post(`${API_ROOT}/getprofileDetail`, 
        {}, 
        {
            headers: {
                authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        })
        //const response = await axios.get('/getprofileDetail/'+localStorage.getItem("token"));
        if(response.data.success === true){
           return response.data.data[0]
        }
    }catch (error){
        return error
    }
}

